import logoDark from "@/assets/logo.png";
import logoLight from "@/assets/logo-negative.png";

interface LogoProps {
  variant?: "dark" | "light";
  className?: string;
}

const Logo = ({ variant = "dark", className = "" }: LogoProps) => {
  return (
    <img
      src={variant === "dark" ? logoDark : logoLight}
      alt="Photosynthetic"
      width={300}
      height={60}
      className={`h-6 w-auto ${className}`}
    />
  );
};

export default Logo;
